// src/store/store.js
import {configureStore} from "@reduxjs/toolkit";
import {persistStore, persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage"; // You can use sessionStorage instead, if needed
import rootReducer from "./redux/reducers";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // Add the names of the reducers you want to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"], // ignore actions that aren't serializable
      },
    }),
});

export const persistor = persistStore(store);
export default store;
